export interface IntakeFormData {
  // Step 1: Business Info
  businessName: string;
  industry: string;
  website: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  location: string;

  // Step 2: Services
  services: string[];
  projectDescription: string;
  goals: string;

  // Step 3: Brand & Assets
  hasLogo: string;
  brandColors: string;
  brandPersonality: string[];
  competitorSites: string;
  inspiration: string;

  // Step 4: Timeline & Budget
  timeline: string;
  budget: string;
  additionalNotes: string;

  // Assets
  uploadedFiles: string[]; // Uploadcare CDN URLs
}

export const SERVICES = [
  'Website Design & Development',
  'Brand Identity & Logo',
  'Photography',
  'Videography',
  'Social Media Management',
  'SEO & Content Marketing',
  'Google Ads / PPC',
  'Email Marketing',
];

export const BRAND_PERSONALITIES = [
  'Professional & Corporate',
  'Fun & Playful',
  'Luxury & Premium',
  'Bold & Edgy',
  'Warm & Friendly',
  'Minimal & Clean',
  'Rugged & Industrial',
  'Creative & Artistic',
];

export const TIMELINES = [
  'ASAP (rush — within 2 weeks)',
  '1 month',
  '2–3 months',
  '3–6 months',
  'Flexible / No rush',
];

export const BUDGETS = [
  'Under $1,000',
  '$1,000 – $2,500',
  '$2,500 – $5,000',
  '$5,000 – $10,000',
  '$10,000+',
  'Not sure yet',
];
